import { render, staticRenderFns } from "./SightseeingCard.vue?vue&type=template&id=266f58c1&scoped=true"
import script from "./SightseeingCard.vue?vue&type=script&lang=js"
export * from "./SightseeingCard.vue?vue&type=script&lang=js"
import style0 from "./SightseeingCard.vue?vue&type=style&index=0&id=266f58c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266f58c1",
  null
  
)

export default component.exports